import React from 'react';
import { Admin, Resource } from 'react-admin';
import { dataProvider } from './dataProvider';
import { authProvider } from './authProvider';
import { users } from './users';
import { roles } from './roles';

// /admin/*: users and roles, for UserManagement.Admin.
export const AdminPage: React.FC = () => (
    <Admin basename="/admin" dataProvider={dataProvider} authProvider={authProvider} requireAuth>
        <Resource name="users" {...users} />
        <Resource name="roles" {...roles} />
        <Resource name="features" />
    </Admin>
);
